import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/tools/ToolShell";

export const Route = createFileRoute("/fr/privacy-policy")({
  head: () => ({
    meta: [
      { title: "Politique de Confidentialité — Picamini.online" },
      {
        name: "description",
        content: "Découvrez notre politique de confidentialité : aucun téléversement de fichier, traitement 100% local dans le navigateur et respect strict du RGPD.",
      },
    ],
    links: [
      { rel: "canonical", href: "https://picamini.online/fr/politique-de-confidentialite" },
      { rel: "alternate", hrefLang: "en", href: "https://picamini.online/privacy-policy" },
      { rel: "alternate", hrefLang: "es", href: "https://picamini.online/es/politica-de-privacidad" },
      { rel: "alternate", hrefLang: "de", href: "https://picamini.online/de/datenschutzrichtlinie" },
      { rel: "alternate", hrefLang: "pt-BR", href: "https://picamini.online/pt-br/politica-de-privacidade" },
      { rel: "alternate", hrefLang: "fr", href: "https://picamini.online/fr/politique-de-confidentialite" },
      { rel: "alternate", hrefLang: "x-default", href: "https://picamini.online/privacy-policy" },
    ],
  }),
  component: FrPrivacyPage,
});

function FrPrivacyPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col font-sans">
      <SiteHeader lang="fr" />

      <main className="flex-1 py-12 mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 space-y-6">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-foreground">Politique de Confidentialité</h1>

        <p className="text-base text-muted-foreground leading-relaxed">
          Chez <strong>Picamini.online</strong>, la confidentialité de nos utilisateurs est notre priorité absolue. Nos outils ont été conçus selon le principe de la protection des données dès la conception (Privacy by Design).
        </p>

        <h2 className="text-xl font-bold text-foreground pt-4">1. Traitement des Fichiers et des Données</h2>
        <p className="text-base text-muted-foreground leading-relaxed">
          Tous nos outils interactifs (tirages au sort, roues, générateurs d'équipes) et outils PDF s'exécutent entièrement en local dans votre navigateur Web via JavaScript et WebAssembly. Aucun fichier PDF, nom d'élève ou liste n'est téléversé sur nos serveurs.
        </p>

        <h2 className="text-xl font-bold text-foreground pt-4">2. Absence de Compte et de Cookies Suiveurs</h2>
        <p className="text-base text-muted-foreground leading-relaxed">
          Picamini.online ne nécessite aucune inscription. Nous n'utilisons aucun cookie de profilage ni de suivi publicitaire intrusif.
        </p>

        <h2 className="text-xl font-bold text-foreground pt-4">3. Stockage Local (LocalStorage)</h2>
        <p className="text-base text-muted-foreground leading-relaxed">
          Afin de conserver vos listes de prénoms d'une session à l'autre pour votre confort, certaines données sont sauvegardées localement dans la mémoire de votre navigateur (LocalStorage). Vous pouvez effacer ces données à tout moment en nettoyant le cache de votre navigateur.
        </p>
      </main>

      <SiteFooter lang="fr" />
    </div>
  );
}
